// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Portrait.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-section {
  font-family: "Lato", Arial, sans-serif;
  font-size: 16px;
  line-height: 1.8;
  font-weight: normal;
  background: #f8f9fd;
  color: gray;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-image: url(../images/bgPaw.png);
  object-fit: contain; */
}

.login-section .form_title {
  font-size: 16px !important;
}

.diamondsOnCallTitle {
  color: var(--primary-color);
  font-weight: 600;
  letter-spacing: 0.1px;
  text-align: center;
}

.login-section a {
  transition: 0.3s all ease;
  color: var(--primary-color);
  text-decoration: none;
  font-size: 14px !important;
}

.login-section a:hover,
.login-section a:focus {
  text-decoration: none !important;
  outline: none !important;
  box-shadow: none;
  color: var(--secondary-color);
}

.heading-section {
  font-size: 28px;
  color: #000;
}

.login-section .img {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  /* background-image: url("../images/diamond_on_call.png"); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin: 20px;
  /* background-image: url("../images/40211.svg"); */
  /* background-image: url("../images/diamonds_icon.png") */
}

.login-section .wrap {
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
}

.login-section .img,
.login-wrap {
  width: 50%;
}

@media (max-width: 991.98px) {
  .img,
  .login-wrap {
    width: 100%;
  }
}

@media (max-width: 767.98px) {
  .wrap .img {
    height: 250px;
    width: 100%;
  }
  .login-section .img {
    margin: 0px;
  }
}

.login-wrap {
  position: relative;
}

.form-group {
  position: relative;
}

.form-group .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #000;
  font-weight: 700;
  display: block;
  font-size: 11px;
  margin-bottom: 2px;
}

.forgot_password {
  margin-top: 20px;
}

.forgot_password a:hover {
  color: var(--secondary-color);
}

.signInLink {
  margin-top: 20px;
}

.form-group a {
  color: gray;
}

.form-control {
  height: 48px;
  background: #fff;
  color: #000;
  font-size: 14px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #00000038;
}

.form-control::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:focus,
.form-control:active {
  outline: none !important;
  box-shadow: none;
  border: 1px solid var(--secondary-color);
}

.passwordInputField {
  position: relative;
  z-index: 0;
  margin-bottom: 20px !important;
}

.passwordInputField span {
  position: absolute;
  top: 70%;
  right: 11px;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.signInBtn {
  cursor: pointer;
  box-shadow: none !important;
  font-size: 15px;
  padding: 10px 20px;
  position: relative;
}

.signInBtn:hover,
.signInBtn:active,
.btn:focus {
  outline: none;
}

.signInBtn.btn-primary {
  background: var(--primary-color) !important;
  border: 1px solid var(--primary-color) !important;
  color: #fff !important;
  margin-top: 10px;
}

.signInBtn.btn-primary:hover {
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
}

.signInBtn.btn-primary.btn-outline-primary {
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
}

.signInBtn.btn-primary.btn-outline-primary:hover {
  border: 1px solid transparent;
  background: var(--primary-color);
  color: #fff;
}

.addMemberBtn {
  cursor: pointer;
  box-shadow: none !important;
  font-size: 15px;
  padding: 7.5px 41px;
  position: relative;
}

.generateSelectedBtn {
  cursor: pointer;
  box-shadow: none !important;
  font-size: 15px;
  padding: 8px 70px;
  position: relative;
}

.saveChangesBtn {
  cursor: pointer;
  box-shadow: none !important;
  font-size: 15px;
  padding: 7.2px 43px;
  position: relative;
}
.resetPassBtn {
  cursor: pointer;
  box-shadow: none !important;
  font-size: 15px;
  padding: 7.2px 47.5px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;wBACsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EAGE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;EAChC,wBAAwB;EAExB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,4DAA4D;EAC5D,yDAA+C;EAC/C,YAAY;EACZ,kDAAkD;EAClD,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAGlB,mDAAmD;AACrD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAElB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EAExB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EAGX,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EAEf,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,eAAe;EAEf,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EAEf,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EAEf,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EAEf,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB","sourcesContent":[".login-section {\n  font-family: \"Lato\", Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.8;\n  font-weight: normal;\n  background: #f8f9fd;\n  color: gray;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background-image: url(../images/bgPaw.png);\n  object-fit: contain; */\n}\n\n.login-section .form_title {\n  font-size: 16px !important;\n}\n\n.diamondsOnCallTitle {\n  color: var(--primary-color);\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  text-align: center;\n}\n\n.login-section a {\n  -webkit-transition: 0.3s all ease;\n  -o-transition: 0.3s all ease;\n  transition: 0.3s all ease;\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 14px !important;\n}\n\n.login-section a:hover,\n.login-section a:focus {\n  text-decoration: none !important;\n  outline: none !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: var(--secondary-color);\n}\n\n.heading-section {\n  font-size: 28px;\n  color: #000;\n}\n\n.login-section .img {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  /* background-image: url(\"../images/diamond_on_call.png\"); */\n  background-image: url(\"../images/Portrait.svg\");\n  margin: 20px;\n  /* background-image: url(\"../images/40211.svg\"); */\n  /* background-image: url(\"../images/diamonds_icon.png\") */\n}\n\n.login-section .wrap {\n  width: 100%;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 5px;\n  -webkit-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);\n  box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);\n}\n\n.login-section .img,\n.login-wrap {\n  width: 50%;\n}\n\n@media (max-width: 991.98px) {\n  .img,\n  .login-wrap {\n    width: 100%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .wrap .img {\n    height: 250px;\n    width: 100%;\n  }\n  .login-section .img {\n    margin: 0px;\n  }\n}\n\n.login-wrap {\n  position: relative;\n}\n\n.form-group {\n  position: relative;\n}\n\n.form-group .label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #000;\n  font-weight: 700;\n  display: block;\n  font-size: 11px;\n  margin-bottom: 2px;\n}\n\n.forgot_password {\n  margin-top: 20px;\n}\n\n.forgot_password a:hover {\n  color: var(--secondary-color);\n}\n\n.signInLink {\n  margin-top: 20px;\n}\n\n.form-group a {\n  color: gray;\n}\n\n.form-control {\n  height: 48px;\n  background: #fff;\n  color: #000;\n  font-size: 14px;\n  border-radius: 5px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid #00000038;\n}\n\n.form-control::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.form-control::-moz-placeholder {\n  /* Firefox 19+ */\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.form-control:-ms-input-placeholder {\n  /* IE 10+ */\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.form-control:-moz-placeholder {\n  /* Firefox 18- */\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.form-control:focus,\n.form-control:active {\n  outline: none !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid var(--secondary-color);\n}\n\n.passwordInputField {\n  position: relative;\n  z-index: 0;\n  margin-bottom: 20px !important;\n}\n\n.passwordInputField span {\n  position: absolute;\n  top: 70%;\n  right: 11px;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  color: rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n}\n\n.signInBtn {\n  cursor: pointer;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  font-size: 15px;\n  padding: 10px 20px;\n  position: relative;\n}\n\n.signInBtn:hover,\n.signInBtn:active,\n.btn:focus {\n  outline: none;\n}\n\n.signInBtn.btn-primary {\n  background: var(--primary-color) !important;\n  border: 1px solid var(--primary-color) !important;\n  color: #fff !important;\n  margin-top: 10px;\n}\n\n.signInBtn.btn-primary:hover {\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--primary-color);\n}\n\n.signInBtn.btn-primary.btn-outline-primary {\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--primary-color);\n}\n\n.signInBtn.btn-primary.btn-outline-primary:hover {\n  border: 1px solid transparent;\n  background: var(--primary-color);\n  color: #fff;\n}\n\n.addMemberBtn {\n  cursor: pointer;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  font-size: 15px;\n  padding: 7.5px 41px;\n  position: relative;\n}\n\n.generateSelectedBtn {\n  cursor: pointer;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  font-size: 15px;\n  padding: 8px 70px;\n  position: relative;\n}\n\n.saveChangesBtn {\n  cursor: pointer;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  font-size: 15px;\n  padding: 7.2px 43px;\n  position: relative;\n}\n.resetPassBtn {\n  cursor: pointer;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  font-size: 15px;\n  padding: 7.2px 47.5px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
